import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, MessageCircle } from 'lucide-react';
import { Button } from './ui/Button';
export function ScreenPrintingTeaser() {
  return <section className="relative py-20 border-t border-white/5 overflow-hidden" data-id="element-336">
      {/* Background image */}
      <div className="absolute inset-0 z-0" data-id="element-337">
        <img src="https://cdn.magicpatterns.com/uploads/7JFyFy99e1Go7yTQGkxfea/screen-printing-lansing-michigan.jpg" alt="Custom screen printed hoodies and apparel on display" className="absolute inset-0 w-full h-full object-cover" data-id="element-338" />
        <div className="absolute inset-0 bg-atomic-black/75" data-id="element-339" />
        <div className="absolute inset-0 bg-gradient-to-r from-atomic-black/85 via-atomic-black/70 to-atomic-black/60" data-id="element-340" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-341">
        <div className="max-w-5xl mx-auto" data-id="element-342">
          <div className="grid lg:grid-cols-2 gap-10 items-center" data-id="element-343">
            {/* Left: Content */}
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} data-id="element-344">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/5 border border-white/10 text-atomic-green text-sm font-medium mb-4" data-id="element-345">
                <span className="w-1.5 h-1.5 rounded-full bg-atomic-green" data-id="element-346" />
                Trusted Since Day One
              </div>

              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-347">
                Screen Printing
              </h2>

              <p className="text-lg text-gray-300 leading-relaxed mb-3" data-id="element-348">
                Bold, durable screen prints for businesses, race teams, events,
                and organizations. No minimums, no setup fees.
              </p>

              <p className="text-gray-500 text-sm mb-6" data-id="element-349">
                Typical 7–10 business days after art approval & payment
              </p>

              <div className="flex flex-col sm:flex-row gap-3" data-id="element-350">
                <a href="/screen-printing" data-id="element-351">
                  <Button size="lg" className="gap-2" data-id="element-352">
                    Learn More
                    <ArrowRight className="w-4 h-4" data-id="element-353" />
                  </Button>
                </a>
                <a href="sms:+15174149232" data-id="element-354">
                  <Button variant="outline" size="lg" className="gap-2" data-id="element-355">
                    <MessageCircle className="w-4 h-4" data-id="element-356" />
                    Text Us to Start
                  </Button>
                </a>
              </div>
            </motion.div>

            {/* Right: Visual process strip */}
            <motion.div initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.15
          }} className="bg-atomic-charcoal rounded-xl p-8 border border-white/10" data-id="element-357">
              <h3 className="text-lg font-bold text-white mb-6" data-id="element-358">
                Simple Process
              </h3>
              <div className="space-y-4" data-id="element-359">
                {[{
                num: '1',
                label: 'Request',
                desc: 'Text or message us your idea'
              }, {
                num: '2',
                label: 'Proof',
                desc: 'We send a digital mockup'
              }, {
                num: '3',
                label: 'Approve & Pay',
                desc: 'Confirm and we start printing'
              }, {
                num: '4',
                label: 'Print',
                desc: 'Your order is produced'
              }, {
                num: '5',
                label: 'Pickup or Ship',
                desc: 'Ready in 7–10 business days'
              }].map((step, i) => <div key={step.num} className="flex items-start gap-4" data-id="element-360">
                    <div className="w-8 h-8 rounded-full bg-atomic-green/10 border border-atomic-green/30 flex items-center justify-center text-atomic-green text-sm font-bold shrink-0" data-id="element-361">
                      {step.num}
                    </div>
                    <div data-id="element-362">
                      <span className="text-white font-medium" data-id="element-363">
                        {step.label}
                      </span>
                      <span className="text-gray-500 text-sm ml-2" data-id="element-364">
                        {step.desc}
                      </span>
                    </div>
                  </div>)}
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}